import { createSlice } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
interface DarkModeState {
  darkMode: boolean;
}

const initialState: DarkModeState = {
  darkMode: false
};

const persistConfig: PersistConfig<DarkModeState> = {
  key: 'theme',
  storage
};

const darkModeSlice = createSlice({
  name: 'darkMode',
  initialState,
  reducers: {
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
    }
  }
});

const { toggleDarkMode } = darkModeSlice.actions;
export { toggleDarkMode };

export default persistReducer(persistConfig, darkModeSlice.reducer);
